import queryString from 'query-string';

export default () => {
	const {projectId = null, primaryEngagementId = null, componentId = null} = queryString.parse(location.search);

	return {projectId, primaryEngagementId, componentId};
};
